import { forwardRef } from "react";
function SvgRawLeftAlignIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeWidth={2}
        d="M4 6h11M4 10h16M4 14h13M4 18h16"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawLeftAlignIcon);
export default ForwardRef;
